// import action types
import { UPDATE_APP_CONTEXT, CLEAR_USER_SESSION } from 'constants/redux-events';

/********************************************************/
// intial userInfo state
const initialState = {};

/**
 * @type {function}
 * @desc A Redux Reducer to manage state of the Redux Store
 * @param {object} [state={}] - Current state of the Redux Store at given state key
 * @param {object} action - Redux **action** object with **event name** and **payload**
 * @example
 * import { updateAppContext } from 'reducers/updateAppContext';
 */
export const updateAppContext = ( state = {}, action ) => {
    const { type, payload } = action;

    switch( type ) {
		case UPDATE_APP_CONTEXT: {
			return {
				...state,
                ...payload
			};
		}
        case CLEAR_USER_SESSION:
            return initialState;
        default:
            return state;
    }
};
